import { useEffect, useRef, useState } from 'react';
import { completeAxonLogin } from './axon-auth';

/** Lands the OAuth redirect: exchanges the code, then hands over to the app. */
export function Callback({ onSignedIn }: { onSignedIn: () => void }) {
  const ran = useRef(false);
  const [error, setError] = useState<string | null>(null);
  // The exchange runs once; call whichever handler is current when it ends.
  const signedIn = useRef(onSignedIn);
  signedIn.current = onSignedIn;

  useEffect(() => {
    if (ran.current) return; // guard React StrictMode double-invoke
    ran.current = true;

    void (async () => {
      try {
        await completeAxonLogin();
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
        return;
      }
      // The code and state are spent; keep them out of the address bar and
      // history. Not in the try above: a failure past here is not a failed
      // sign-in. If handing over in place fails, a full load of / restores
      // the session from the refresh cookie /token just set.
      try {
        window.history.replaceState(null, '', '/');
        signedIn.current();
      } catch {
        window.location.replace('/');
      }
    })();
  }, []);

  if (error) {
    return (
      <div className="center">
        <div className="card">
          <p>Sign-in failed: {error}</p>
          <a href="/">Back to sign in</a>
        </div>
      </div>
    );
  }

  return (
    <div className="center">
      <p>Signing in…</p>
    </div>
  );
}
